export default {
  tips: '我们发送了一封激活邮件给您(如未收到，请查看垃圾邮件）',
  verifyEmail: '激活账号',
  securityCode: '验证码',
  sendAgain: '再次发送',
  second: '{second}秒',
  title: '请查看邮箱',

  //
  backLogin: '返回登录',
  tokenEmpty: '验证码必填',
  passSended: '请查看邮箱',
  activatingEmail: '我们发送了一份验证码给您的邮箱',
  activate: '激活账户',
  emailValidationSuccess: '邮件验证通过',
  emailValidationFailure: '验证邮件失败，请重新登录获取新的账户激活链接',
}
